import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Clienthomemenu from "../Menus/Clienthomemenu";
import jsPDF from "jspdf";
import "jspdf-autotable"; // ✅ Correct import for autoTable
import addGujaratiFont from "../fonts/NotoSansGujarati";
import { autoTable } from "jspdf-autotable";
const TestReview = () => {
  const location = useLocation();
  const { TEST_ID, TEST_NAME } = location.state || {};

  const user = JSON.parse(localStorage.getItem("user"));
  const UID = user?.UID;
  const fullname = localStorage.getItem("fullname");

  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch test review data
  useEffect(() => {
    if (!TEST_ID || !UID) return;

    const fetchReview = async () => {
      try {
        const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_GET_STUDENT_WISE_TEST_DETAIL}`;
        const res = await fetch(path, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ TEST_ID, UID }),
        });
        const data = await res.json();
        if (data.res === "Success") setQuestions(data.data);
      } catch (err) {
        console.error("Review API Error", err);
      } finally {
        setLoading(false);
      }
    };

    fetchReview();
  }, [TEST_ID, UID]);

  // Download PDF
  const downloadPDF = () => {
    const doc = new jsPDF({
      orientation: "portrait", // portrait better for paper format
      unit: "mm",
      format: "a4",
    });

    addGujaratiFont(doc);
    doc.setFont("NotoGujarati", "normal");

    let y = 20;

    const total = questions.length;
    const correct = questions.filter(
      (q) => q.ANS_IN_SEQ === q.GIVEN_ANS,
    ).length;
    const wrong = total - correct;

    // ===== Heading =====
    // ===== HEADER SECTION =====
    const storedITIName = user?.ITI_NAME?.trim();
    const itiName = storedITIName
      ? `INDUSTRIAL TRAINING INSTITUTE ${storedITIName}`
      : "INDUSTRIAL TRAINING INSTITUTE ___________";
    //const itiName = "INDUSTRIAL TRAINING INSTITUTE ___________"; // 👈 tamaru ITI naam
    const examDate = new Date().toLocaleDateString("en-GB"); // 11/02/2026 format

    doc.setFont("NotoGujarati", "normal");

    // ITI NAME (BIG FONT)
    doc.setFontSize(22);
    doc.text(itiName, doc.internal.pageSize.getWidth() / 2, y, {
      align: "center",
    });
    y += 10;

    // EXAM TITLE
    doc.setFontSize(16);
    doc.text("Quarterly Test Paper", doc.internal.pageSize.getWidth() / 2, y, {
      align: "center",
    });
    y += 10;

    // DETAILS (CENTER ALIGN)
    doc.setFontSize(12);

    doc.text(
      `Test Name : ${TEST_NAME}`,
      doc.internal.pageSize.getWidth() / 2,
      y,
      { align: "center" },
    );
    y += 6;

    doc.text(
      `Student Name : ${fullname}`,
      doc.internal.pageSize.getWidth() / 2,
      y,
      { align: "center" },
    );
    y += 6;

    doc.text(
      `Total Questions : ${total}`,
      doc.internal.pageSize.getWidth() / 2,
      y,
      { align: "center" },
    );
    y += 6;

    doc.text(
      `Exam Date : ${examDate}`,
      doc.internal.pageSize.getWidth() / 2,
      y,
      { align: "center" },
    );

    y += 8;

    // HORIZONTAL LINE
    doc.line(20, y, doc.internal.pageSize.getWidth() - 20, y);

    y += 10;

    // ===== QUESTION FORMAT TABLE =====
    const bodyData = questions.map((q, index) => {
      const correctAns = q.ANS_IN_SEQ;
      const userAns = q.GIVEN_ANS || "Not Attempted";

      const isCorrect = correctAns === q.GIVEN_ANS;

      return [
        `Q${index + 1}. ${q.QUESTION}

A) ${q.OPT1}        B) ${q.OPT2}

C) ${q.OPT3}        D) ${q.OPT4}

Correct Answer : ${correctAns}
Student Answer : ${userAns}
Result : ${userAns === "Not Attempted" ? "Not Attempted" : isCorrect ? "Right ✅" : "Wrong ❌"}
`,
      ];
    });

    autoTable(doc, {
      startY: y,
      body: bodyData,
      styles: {
        font: "NotoGujarati",
        fontStyle: "normal",
        fontSize: 11,
        cellPadding: 4,
        overflow: "linebreak",
        valign: "top",
      },
      columnStyles: {
        0: { cellWidth: 180 },
      },
      theme: "plain",
    });

    doc.save(`EasyITI_Paper_${TEST_ID}.pdf`);
  };

  return (
    <>
      <Clienthomemenu title="EasyITI" testhistory="testhistory" />
      <div
        className="container"
        style={{
          paddingTop: "90px",
          height: "auto",
        }}
      >
        <h4 className="text-center mb-4">
          🧠 Test Review {TEST_NAME && `- ${TEST_NAME}`}
          <div className="text-center mb-3">
            <button className="btn btn-danger" onClick={downloadPDF}>
              ⬇ Download PDF
            </button>
          </div>
        </h4>

        {loading && (
          <div className="text-center">
            <div className="spinner-border text-primary"></div>
          </div>
        )}

        {!loading &&
          questions.map((q, index) => {
            const correctAns = q.ANS_IN_SEQ;
            const userAns = q.GIVEN_ANS || "";
            const isCorrect = correctAns === userAns;

            return (
              <div key={q.QUE_UID} className="card mb-3 shadow-sm">
                <div className="card-body">
                  <h6 className="mb-3">
                    {index + 1}. {q.QUESTION}
                  </h6>
                  {["A", "B", "C", "D"].map((opt, i) => {
                    const text = q[`OPT${i + 1}`];
                    let cls = "border p-2 rounded mb-1";
                    if (opt === correctAns) cls += " bg-success text-white";
                    else if (opt === userAns) cls += " bg-danger text-white";
                    return (
                      <div key={opt} className={cls}>
                        {opt}. {text}
                      </div>
                    );
                  })}

                  <div className="mt-3">
                    <span className="badge bg-success me-2">
                      Correct Answer: {correctAns}
                    </span>
                    <span
                      className={`badge ${userAns === "" ? "bg-secondary" : isCorrect ? "bg-success" : "bg-danger"}`}
                    >
                      Your Answer: {userAns || "Not Attempted"}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}

        {!loading && questions.length === 0 && (
          <div className="alert alert-warning text-center">
            No review data found
          </div>
        )}
      </div>
    </>
  );
};

export default TestReview;
